var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 990 720"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E32"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E32",
    className: "cls-2",
    points: "73 231 141 231 141 221 239 221 239 342 190 342 190 310 73 310 73 231"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "E33"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E33",
    className: "cls-2",
    x: 242,
    y: 231,
    width: 99,
    height: 111
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "E34"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E34",
    className: "cls-2",
    x: 344,
    y: 231,
    width: 121,
    height: 111
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "E20"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E20",
    className: "cls-2",
    x: 576,
    y: 231,
    width: 70,
    height: 111
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "E21"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E21",
    className: "cls-2",
    x: 649,
    y: 231,
    width: 98,
    height: 111
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "E22"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E22",
    className: "cls-2",
    points: "751 221 849 221 849 231 917 231 917 310 801 310 801 342 751 342 751 221"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "E23"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E23",
    className: "cls-2",
    points: "804 313 917 313 917 405 804 405 804 371 782 371 782 345 804 345 804 313"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "E24"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E24",
    className: "cls-2",
    points: "917 409 917 486 849 486 849 499 751 499 751 374 801 374 801 409 917 409"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "E25"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E25",
    className: "cls-2",
    points: "747 381 747 486 649 486 649 374 723 374 723 381 747 381"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "E26"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E26",
    className: "cls-2",
    points: "646 374 646 486 547 486 547 381 571 381 571 374 646 374"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "E27"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E27",
    className: "cls-2",
    points: "544 381 544 486 446 486 446 374 520 374 520 381 544 381"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "E28"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E28",
    className: "cls-2",
    points: "443 374 443 486 344 486 344 381 368 381 368 374 443 374"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "E29"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E29",
    className: "cls-2",
    points: "341 381 341 486 243 486 243 374 317 374 317 381 341 381"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "E30"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E30",
    className: "cls-2",
    points: "239 374 239 499 141 499 141 486 73 486 73 409 190 409 190 374 239 374"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "E31"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E31",
    className: "cls-2",
    points: "187 313 187 345 207 345 207 371 187 371 187 406 73 406 73 313 187 313"
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgP2 as ReactComponent };